const sortByKey = (items, index, isDesc, key) => {
    items.sort((a, b) => {
        if (isDesc) {
            if (typeof b[key] === 'string' && typeof a[key] === 'string') {
                return b[key].localeCompare(a[key], {
                    numeric: true,
                    sensitivity: 'base'
                });
            } else {
                return b[key] - a[key];
            }
        }
        if (typeof b[key] === 'string' && typeof a[key] === 'string') {
            return a[key].localeCompare(b[key], {
                numeric: true,
                sensitivity: 'base'
            });
        } else {
            return a[key] - b[key];
        }
    });
    return items;
};

export default [
    {
        name: 'Nach Anzeigename sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'displayName');
        }
    },
    {
        name: 'Nach Vorname sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'firstName');
        }
    },
    {
        name: 'Nach Nachname sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'lastName');
        }
    },
    {
        name: 'Nach Personalnummer sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'personalNumber');
        }
    },
    {
        name: 'Nach E-mail sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'email');
        }
    },
    {
        name: 'Nach Aktiv sortieren',
        sort: (items, index, isDesc) => {
            return sortByKey(items, index, isDesc, 'active');
        }
    }
];
